@if (locationPermissionService.showDialog()) {
  <p-dialog 
    [visible]="true"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    [showHeader]="false"
    styleClass="location-settings-dialog"
    (onHide)="onClose()">
    
    <div class="dialog-content">
      <div class="icon-container">
        <div class="icon-background">
          <i class="pi pi-map-marker"></i>
        </div>
        <div class="permission-badge">
          <i class="pi pi-lock"></i>
        </div>
      </div>
      
      <h2 class="dialog-title">{{ 'location.permission_required' | translate }}</h2>
      
      <p class="dialog-message">{{ 'location.permission_denied_message' | translate }}</p>
      
      <a 
        class="help-link" 
        [href]="locationPermissionService.helpUrl" 
        target="_blank" 
        rel="noopener noreferrer">
        <i class="pi pi-external-link"></i>
        <span>{{ 'location.how_to_enable_link' | translate }}</span>
      </a>
      
      <div class="dialog-actions">
        <p-button 
          [label]="'location.try_again' | translate"
          icon="pi pi-refresh"
          styleClass="try-again-button"
          (onClick)="onTryAgain()" />
        
        <p-button 
          [label]="'common.close' | translate"
          [text]="true"
          (onClick)="onClose()" />
      </div>
    </div>
  </p-dialog>
}
